import conf from '../conf/ajax';
import { clone_object, after, query_builder_next } from './utils';

const get_best_tags_from_server = () =>
{
    return new Promise((resolve, reject) =>
    {
        fetch(conf.endpoints.get_best_tags, conf.ajax_configuration_object).then(res =>
        {
            resolve(res);
        }).catch(err =>
        {
            reject(err);
        });
    });
};

const get_tags_from_server = async () =>
{
    let obj =
    {
        status: '',
        data: [],
        err: null
    };
    try
    {
        const response = await fetch(conf.endpoints.get_all_tags, conf.ajax_configuration_object);
        const data = await response.json()
        obj.status = 'ok';
        obj.data = data;
    }
    catch(err)
    {
        obj.err = err;
    }
    return obj;
};

const get_all_tags_data = async () =>
{
    return fetch(conf.endpoints.get_all_tags+'?stats=1&followed=1', conf.ajax_configuration_object);
};

const get_question_and_its_data_by_id = async (id) =>
{
    return fetch(conf.plone_site + conf.server.answer.replace('{id}', id),conf.ajax_configuration_object);
};


const get_question_and_data_by_id = async (id) =>
{
    const response = await fetch(conf.plone_site + conf.server.answer.replace('{id}', id),conf.ajax_configuration_object);
    const data = await response.json();
    return data;
};

const get_questions = async (obj) =>
{
    const url = query_builder_next(obj, conf)
    return fetch(url, conf.ajax_configuration_object);
}

const get_question_stats = async (question_id) =>
{
    const url = `${conf.plone_site}${conf.server.main_folder}${question_id}/@get-question-stat`;
    const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;
}

const get_question_by_user = async (userid) =>
{
    const url = `${conf.endpoints.userinfo}?user=${userid}`;
    /*const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;*/
    return fetch(url, conf.ajax_configuration_object);
};

const get_followed_question_by_current_user = async () =>
{
    const url = `${conf.plone_site}/${conf.server.followed_questions}`;
    const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;
};

const get_followed_question_by_user = async (userid) =>
{
    const url = `${conf.plone_site}/${conf.server.followed_questions}?userid=${userid}`;
    const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;
};

const get_approved_question_by_user = async (userid) =>
{
    const url = `${conf.plone_site}/${conf.server.approved_questions}?userid=${userid}`;
    const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;
};

const get_answered_question_by_user = async (userid) =>
{
    const url = `${conf.plone_site}/${conf.server.answered_questions}?userid=${userid}`;
    const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;
};

const get_commented_question_by_user = async (userid) =>
{
    const url = `${conf.plone_site}/${conf.server.commented_questions}?userid=${userid}`;
    const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;
};

const get_voted_question_by_current_user = async () =>
{
    const url = `${conf.plone_site}/${conf.server.voted_questions}`;
    const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;
};

const get_voted_question_by_user = async (userid) =>
{
    const url = `${conf.plone_site}/${conf.server.voted_questions}?userid=${userid}`;
    const response = await fetch(url, conf.ajax_configuration_object);
    const data = await response.json()
    return data;
};

const user_api =
{
    get_question_by_user: get_question_by_user,
    get_followed_question_by_current_user: get_followed_question_by_current_user,
    get_followed_question_by_user: get_followed_question_by_user,
    get_voted_question_by_current_user: get_voted_question_by_current_user,
    get_voted_question_by_user: get_voted_question_by_user,
    get_approved_question_by_user: get_approved_question_by_user,
    get_answered_question_by_user: get_answered_question_by_user,
    get_commented_question_by_user: get_commented_question_by_user
};

const post_image = (data, url) =>
{
    return new Promise((resolve, reject) =>
    {
        let json_data = {}
        if(data.attach_type === 'image')
        {
            json_data = {
                "@type": "Image",
                "title": data.title,
                "id": data.id,
                "image": {
                    "data": data.data.split(',')[1],//data.data,
                    "encoding": "base64",
                    "filename": data.name,
                    "content-type": data.mime
                }
            };
        }
        else if(data.attach_type === 'attach')
        {
            json_data = {
                "@type": "File",
                "title": data.title,
                "id": data.id,
                "file": {
                    "data": data.data.split(',')[1],//data.data,
                    "encoding": "base64",
                    "filename": data.name,
                    "content-type": data.mime
                }
            };
        }
        else
        {
            console.error('wrong attchmen type in post_image')
            reject(false);
        }
    

        let data_obj = clone_object(conf.ajax_configuration_object);
        data_obj.method = 'POST';
        data_obj.body = JSON.stringify(json_data);
        fetch(url, data_obj).then(function(response)
        {
            if(response.ok) return response.json(); else reject(false);
        })
        .then(function(data)
        {
            if(data['@type'].toLowerCase() === 'file')
            {
                resolve();
            }
        }).catch(error =>
        {
            console.error('Error:', error);
            reject(error);
        });
    });
};

const send_images = (array_of_images, url) =>
{
    const post_uri = `${conf.endpoints.main}${conf.server.main_folder}${url}`;
    return new Promise((resolve, reject) =>
    {
        let status = {};
        let all_ok = true;
        const last_cb = after(array_of_images.length, () =>
        {
            console.log("LAST CB CALLED");
            status.all_ok = all_ok;
            resolve(status);
        });
        if(array_of_images.length > 0)
        {
            array_of_images.forEach(image_data =>
            {
                post_image(image_data, post_uri).then((res) =>
                {
                    last_cb();
                }).catch(err =>
                {
                    all_ok = false;
                    last_cb();
                });
            });
        }
        else
        {
            resolve(status);
        }
    });
};

const parsing_local_html = (value, imageset) =>
{
    let tmp = value;
    for(let i=0; i<imageset.length; i++)
    {
        tmp = tmp.replace(`](${imageset[i].id})`, `](${imageset[i].data})`);
    }
    return tmp;
};

const get_user_data_by_id = async (user_id) =>
{
    const url = `${conf.endpoints.userinfo}?user=${user_id}`;
    return fetch(url, conf.ajax_configuration_object);
};

const follow_tag = async (tag_id) =>
{
    const url = conf.endpoints.follow_tag;
    let data_obj = clone_object(conf.ajax_configuration_object);
    data_obj.method = 'POST';
    data_obj.body = JSON.stringify({method:'ADD', tag:tag_id});
    return fetch(url, data_obj);
};

const unfollow_tag = async (tag_id) =>
{
    const url = conf.endpoints.follow_tag;
    let data_obj = clone_object(conf.ajax_configuration_object);
    data_obj.method = 'POST';
    data_obj.body = JSON.stringify({method:'REMOVE', tag:tag_id});
    return fetch(url, data_obj);
};

const set_user_settings = async (data) =>
{
    const url = conf.endpoints.get_user_prefs;
    let data_obj = clone_object(conf.ajax_configuration_object);
    data_obj.method = 'POST';
    data_obj.body = JSON.stringify(data);
    return fetch(url, data_obj);
};

const i_have_viewed_that = async (question_id) =>
{
    let view_data = sessionStorage.getItem('qa_viewed_ids');
    let qa_viewed_ids = {};
    if(view_data !== null)
    {
        qa_viewed_ids = JSON.parse(view_data);
    }
    if(question_id in qa_viewed_ids) return null;
    const url = `${conf.plone_site}${conf.server.view_an_answeer.replace('{id}', question_id)}`;
    console.log("i viewed id => " + question_id + " url => " + url);
    let data_obj = clone_object(conf.ajax_configuration_object);
    data_obj.method = 'HEAD';
    return fetch(url, data_obj);
};

const put_ids_in_question_viewed = (question_id) =>
{
    let view_data = sessionStorage.getItem('qa_viewed_ids');
    let qa_viewed_ids = (view_data !== null) ? JSON.parse(view_data) : {};
    qa_viewed_ids[question_id] = true;
    sessionStorage.setItem('qa_viewed_ids', JSON.stringify(qa_viewed_ids));
};

const approve_question_by_id = async (question_id) =>
{
    let data_obj = clone_object(conf.ajax_configuration_object);
    data_obj.method = 'POST';
    return fetch(conf.plone_site + conf.server.approve.replace('{id}', question_id), data_obj);
};

const remove_approve_question_by_id = async (question_id) =>
{
    let data_obj = clone_object(conf.ajax_configuration_object);
    data_obj.method = 'DELETE';
    return fetch(conf.plone_site + conf.server.approve.replace('{id}', question_id), data_obj);
};

export
{
    set_user_settings,
    get_question_and_data_by_id,
    get_best_tags_from_server,
    get_tags_from_server,
    user_api,
    get_question_stats,
    send_images,
    parsing_local_html,
    get_questions,
    get_all_tags_data,
    get_question_and_its_data_by_id,
    get_user_data_by_id,
    follow_tag,
    unfollow_tag,
    i_have_viewed_that,
    put_ids_in_question_viewed,
    approve_question_by_id,
    remove_approve_question_by_id
};
